import mentenggrand1 from "./Untitled-design-29.webp";
import mentenggrand2 from "./4-7.webp";

const mentenggrand = [mentenggrand1, mentenggrand2];

export default mentenggrand;
